import { HttpResponse1532ob1hsse1y as HttpResponse } from './HttpResponse.mjs';
import {
  ByteReadChannel2wzou76jce72d as ByteReadChannel,
  Companion_getInstance1wcuorfuztxv3 as Companion_getInstance,
} from '../../../../../ktor-ktor-io/io/ktor/utils/io/ByteReadChannel.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DefaultHttpResponseClass;
function DefaultHttpResponse() {
  if (DefaultHttpResponseClass === VOID) {
    class $ extends HttpResponse() {
      constructor(call, responseData) {
        super();
        this.call_1 = call;
        this.coroutineContext_1 = responseData.callContext_1;
        this.status_1 = responseData.statusCode_1;
        this.version_1 = responseData.version_1;
        this.requestTime_1 = responseData.requestTime_1;
        this.responseTime_1 = responseData.responseTime_1;
        var tmp = this;
        var tmp_0 = responseData.body_1;
        var tmp0_elvis_lhs = isInterface(tmp_0, ByteReadChannel()) ? tmp_0 : null;
        tmp.rawContent_1 = tmp0_elvis_lhs == null ? Companion_getInstance().Empty_1 : tmp0_elvis_lhs;
        this.headers_1 = responseData.headers_1;
      }
      get_call_wojxrb_k$() {
        return this.call_1;
      }
      get_coroutineContext_115oqo_k$() {
        return this.coroutineContext_1;
      }
      get_status_jnf6d7_k$() {
        return this.status_1;
      }
      get_version_72w4j3_k$() {
        return this.version_1;
      }
      get_requestTime_wwxhg3_k$() {
        return this.requestTime_1;
      }
      get_responseTime_scfvg7_k$() {
        return this.responseTime_1;
      }
      get_rawContent_u3f8li_k$() {
        return this.rawContent_1;
      }
      get_headers_ef25jx_k$() {
        return this.headers_1;
      }
    }
    initMetadataForClass($, 'DefaultHttpResponse');
    DefaultHttpResponseClass = $;
  }
  return DefaultHttpResponseClass;
}
//region block: exports
export {
  DefaultHttpResponse as DefaultHttpResponse2wnrinzo0twhn,
};
//endregion

//# sourceMappingURL=DefaultHttpResponse.mjs.map
